module.exports = __webpack_public_path__ + "static/media/Merriweather.6d1f2c44.woff2";